<!--
 * @Author: your name
 * @Date: 2021-10-29 10:54:16
 * @LastEditTime: 2022-06-10 14:00:14
 * @LastEditors: LAPTOP-JM4BAR46
 * @Description: In User Settings Edit
 * @FilePath: \newBj-admin\src\views\center-business\order\preempt\detail.vue
-->
<template>
  <div class="app-container bj-label-colon label-width-6 resize-col">
    <BjDivider right-fixed
      >{{ $t('PreoccupationManagement.view.information') }}
      <template v-slot:right>
        <!-- #ifndef OPEN-SOURCE -->
        <el-button v-if="info.status != 1" type="primary" @click="rePreemptOrderByNoticeId"
          >{{ $t('PreoccupationManagement.view.reserve') }}</el-button
        >
        <!-- #endif -->
        <el-button @click="handleClose">{{ $t('backText') }}</el-button>
      </template>
    </BjDivider>
    <div class="bj-row border-no padding-no mt20">
      <div class="bj-col bj-col-18 padding-no bj-item-col-12">
        <el-form ref="form" inline>
          <el-form-item :label="$t('PreoccupationManagement.form.Third')">
            <span>{{ info.outerOrderNo }}</span>
            <BjCopyIcon :copy="info.outerOrderNo" />
          </el-form-item>
          <el-form-item :label="$t('PreoccupationManagement.form.Internal')">
            <span class="link" @click="$toBusinessOrderInternalView(info.innerOrderNo)">{{
              info.innerOrderNo
            }}</span>
            <BjCopyIcon :copy="info.innerOrderNo" />
          </el-form-item>
          <el-form-item :label="$t('PreoccupationManagement.form.Three')">
            {{ info.orderTime }}
          </el-form-item>
          <el-form-item :label="$t('PreoccupationManagement.form.order')">
            {{ info.creationDate }}
          </el-form-item>
          <el-form-item :label="$t('PreoccupationManagement.form.order')">
            {{ info.predictDeliveryTime }}
          </el-form-item>
        </el-form>
      </div>
      <div class="bj-col bj-col-6 padding-no flex-column flex-center el-progress-box-2022-4-11">
        <!-- <div class="circle" :class="'circle_' + info.status">
          {{ ORDER_ADVANCE_PREEMPT_STATUS_LIST.bjGet(info.status) }}
        </div>

          [0, '全部待预占'],
  [1, '全部预占成功'],
  [3, '全部预占失败'],
  [2, '部分预占'],
  [4, '取消预占'],

  -->
        <el-progress
          type="circle"
          :width="160"
          :stroke-width="30"
          :percentage="progressPercentage"
          :format="progressText"
        ></el-progress>
      </div>
    </div>
    <BjDivider>{{ $t('PreoccupationManagement.view.preemptTitle') }}</BjDivider>
    <GoodsInfoTab
      v-if="tabVisible"
      ref="GoodsInfoTab"
      :order-id="$route.query.id"
      has-btn
      :success="info.status == 1"
      @reFresh="reFresh"
    />
  </div>
</template>
<script>
import viewMiXin from '@/utils/view-mixin.js';
import { orderApi } from '@/api';
import GoodsInfoTab from './GoodsInfoTab';
import { ORDER_ADVANCE_PREEMPT_STATUS_LIST } from '@/utils/constants';
export default {
  name: 'BusinessOrderPreemptView',
  components: { GoodsInfoTab },
  mixins: [viewMiXin],
  data() {
    return {
      ORDER_ADVANCE_PREEMPT_STATUS_LIST,
      tabVisible: true,
      info: {
        creationDate: null,
        innerOrderNo: null,
        orderTime: null,
        outerOrderNo: null,
        predictDeliveryTime: null,
        status: null,
      },
    };
  },
  computed: {
    id() {
      return this.$route.query.id || '';
    },
    progressPercentage() {
      // [0, '全部待预占'],
      // [1, '全部预占成功'],
      // [2, '部分预占'],
      // [3, '全部预占失败'],
      // [4, '取消预占'],
      let p = 0;
      switch (this.info.status) {
        case 0:
          p = 0;
          break;
        case 1:
          p = 100;
          break;
        case 2:
          p = 50;
          break;
        case 3:
          p = 0;
          break;
        case 4:
          p = 0;
          break;
      }
      return p;
    },
  },
  created() {
    this.reFresh();
  },
  methods: {
    progressText() {
      return (this.$t(ORDER_ADVANCE_PREEMPT_STATUS_LIST.bjGet(this.info.status)) || '').replace(this.$t('wholeText'), '');
    },
    reFresh(goodsInfoActiveTab) {
      this.getInfo();
      this.reTabs(goodsInfoActiveTab);
    },
    getInfo() {
      orderApi.getPreemptionOrderDetail({ id: this.id }).then(res => {
        this.info = { ...this.info, ...(res || {}) };
      });
    },
    reTabs(goodsInfoActiveTab) {
      this.tabVisible = false;
      this.$nextTick(() => {
        this.tabVisible = true;
        this.$nextTick(() => {
          if (goodsInfoActiveTab) this.$refs.GoodsInfoTab.goodsInfoActiveTab = goodsInfoActiveTab;
        });
      });
    },
    // #ifndef OPEN-SOURCE
    rePreemptOrderByNoticeId() {
      this.$confirm(`${this.$t('toast.youAreTipText')} ${this.$t('PreoccupationManagement.view.confirmText')}，${this.$t('toast.continueTipText')}`, this.$t('toast.hintText'), {
        confirmButtonText: this.$t('toast.okText'),
        cancelButtonText: this.$t('toast.cancelText'),
        type: 'warning',
      })
        .then(() => {
          orderApi.rePreemptOrderByNoticeId({ noticeId: this.id }).then(res => {
            if (res.id || res._token || res.content || Array.isArray(res) || res.failed === false) {
              this.msgSuccess(this.$t('toast.operationSuccessText'));
              this.reFresh();
            }
          });
        })
        .catch(() => {});
    },
    //  #endif
    handleClose() {
      this.cancel();
    },
  },
};
</script>
<style>
.el-progress-box-2022-4-11 .el-progress__text {
  font-size: 16px !important;
}
</style>
